import React from 'react';
import { Layout, Card, Button, Form, Input, Radio, message, Anchor } from 'antd';
import { FormattedMessage } from 'react-intl';
import { Link } from "react-router-dom";

import '../App.css';

import Header from '../components/Header';
import Footer from '../components/Footer';
import AboutAd from '../components/AboutAd';
import ContentWrapperUI from '../components/ContentWrapperUI';
import PressRelease from '../components/PressRelase';
import TargetingBrand from './TargetingBrand';


const { Content } = Layout;
const { Meta } = Card;


function Home({language, changeLanguage}) {

  return (
    <Layout className="App">
      {
        language === 'ko' ?
          <Link to="event" className="banner-style" target="_blank" >
            <img src={require('../img/startup-bulkup-event/banner@2x.png')} width={1024} height={140}alt="start-up-campaign-banner"/>
          </Link>
          :null
      }
      <Header changeLanguage={changeLanguage} defaultLanguage={language}/>
      <Content className="content">
          {/* 1. 메인 */}
          <Main/>
          <div className='content-elem'>
            <div className='content-image-wrapper'>
              <img src={require('../img/ADsticker001.png')} alt="start-up-campaign-banner"/>
              <img src={require('../img/about-adsticker/01.gif')} alt="start-up-campaign-banner"/>
            </div>
          </div>
          <div className='content-elem'>
            <div className='content-image-wrapper'>
              <img src={require('../img/about-adsticker/02.gif')} alt="start-up-campaign-banner"/>
              <img src={require('../img/ADsticker002.png')}  alt="start-up-campaign-banner"/>
            </div>
          </div>
          <div className='content-elem'>
            <div className='content-image-wrapper'>
              <img src={require('../img/ADsticker003.png')}  alt="start-up-campaign-banner"/>
              <img src={require('../img/about-adsticker/03.gif')}  alt="start-up-campaign-banner"/>
            </div>
          </div>
          {/* 5. 문의하기 */}
          <Contact/>
      </Content>
      <Footer/>
    </Layout>
  );
}


const Main = props => (
  <div className="component-wrapper" style={{background: '#4d49be'}}>
    <div className="main-wrapper">
      <div className="component-box">
        <div className="new"><p>NEW</p></div>
        <div className="main-title">mojitok ADsticker</div>
        <div className="main-description">
          <p>
          <FormattedMessage 
            id="main.description" 
            defaultMessage="If you have a brand mascot and are looking for fresh ways to drive<br></br> your users to web, then it is time to <b>Jump into the Conversation</b><br><br/> with mojitok ADsticker."
            values={{ 
              b: chunks => <span style={{fontWeight:700}}>{chunks}</span>,
              br:() => <br></br>
            }}
          />
          </p>
        </div>
      </div>
    </div>
  </div>
) 

const About = props => (
  <div>
    <p className="title" style={{marginTop:77, marginBottom: 18}}>
      <FormattedMessage id="about.title" defaultMessage="What is an ADsticker?"/>
    </p>
    <div className="description">
      <FormattedMessage
        id="about.description"
        defaultMessage="<p>When a user types a particular word, context, or situation in a messenger,</p><p>ADsticker delivers your brand’s advertising content in the form of a sticker.</p><pit>※Sticker refer to emoticons used on mojitok.</pit>"
        values={{ 
          p : (...chunks) => <p>{chunks}</p>,
          pit : (...chunks) => <p className="description-point">{chunks}</p>
        }}
      />
    </div>
    <img className="about-image" src={require(`../img/about-adsticker-${props.language}@2x.png`)} alt="what is an ADsticker?" width={722}/>

    <div className="about-link-btn-wrapper">
      <Anchor affix={false} style={{ width: 'inherit'}}>
        <Anchor.Link 
          href="/#contact" 
          title={
            <Button type="primary" block className="about-link-btn">
              <FormattedMessage 
                id="about.btn.contactUs" 
                defaultMessage="Contact us"
                values={{ 
                  p : (...chunks) => <p className="about-link-btn-text">{chunks}</p>,
                }}
              />
            </Button>
          }
        />
      </Anchor>
    </div>
  </div>
)


const Feature = props => {
  const features = [
    { 
      key : 'guarantee',
      title : 'Guaranteed views',
      description : 'Know how many views you will get on your ADsticker within your campaign period.'
    },
    { 
      key : 'matching',
      title : 'Creator collaborations',
      description : 'No need to worry about producing your own stickers. Simplify production by collaborating with one of our experienced creators.'
    },
    { 
      key : 'channels',
      title : 'Diverse channels',
      description : 'ADstickers are distributed to a variety of messengers through mojitok, reaching 300,000,000 users around the world.<pit>* mojitok is an intelligent sticker API/SDK that can be implemented in any messaging service.</pit>'
    }
  ]
  return(
    <div>
      <p className="title" style={{marginLeft:63}}><FormattedMessage id="feature.title" defaultMessage="ADsticker의 주요 혜택"/></p>
      <div className="feature-content-wrapper">
        {
          features.map(feature => 
            <Card
              key={feature.key}
              hoverable
              style={{ width: 270, borderRadius: 10, border: 'solid 1px #d8d8d8', backgroundColor: '#f5f5f5' }}
              cover={<div className="feature-card-cover"><img alt="example" src={require(`../img/feature-${feature.key}.svg`)} style={feature.key === 'guarantee' ? {marginLeft: 15} : null}/></div>}
              bodyStyle={{
                background:'#fff',
                borderRadius: '0px 0px 10px 10px',
                height:242,
                padding: '50px 24px 20px 24px',
                borderTop: 'solid 1px #d8d8d8'
              }}
            >
              <Meta 
                title={<FormattedMessage id={`feature.${feature.key}.title`} defaultMessage={feature.title}/>}
                description={<FormattedMessage id={`feature.${feature.key}.description`} defaultMessage={feature.description}
                values={{ 
                  p : (...chunks) => <p style={{marginBottom:0}}>{chunks}</p>,
                  pit : (...chunks) => <p className="description-point feature-card-description" style={props.language === "ko" ? {marginTop: 27} :null}>{chunks}</p>
                }}
                />}
                className="feature-card-meta"
              />
            </Card>
          )
        }
      </div>
    </div>
  )
}

const Contact = props => {
  const formLayout = {
    labelCol: {
      span: 8,
    },
    wrapperCol: {
      span: 15,
    },
    labelAlign: 'left'
  };
  

  const onFinish = values => {
    const url = process.env.REACT_APP_CONTACT_API_URL;
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Api-Key': process.env.REACT_APP_CONTACT_API_KEY
      },
      body: JSON.stringify(values),
    })
    .then(response => {
      console.log(response);
      message.success('Submit successfully.');
    })
    .catch((error) => {
      message.error('Submit failed. Please Try again');
      console.log(error);
    })

  };

  return (
    <div id="contact" className="contact-wrapper">
      <div className="contact-box">
        <div className="contact-title">
          <p>
            <FormattedMessage id="contact.title" 
            defaultMessage="Your AD isn’t in another castle, it’s right here!<br></br>
            Drop us a message to see your mascot <br></br>
            turn into an ADsticker. <br></br>"
              values={{ 
                br:() => <br></br>
              }}
            />
          </p>
        </div>
        <img src={require('../img/emoji@2x.png')} className="contact-form-emoji"/>
        <div className="contact-form-box">
          <Form {...formLayout} name="nest-messages" onFinish={onFinish} size="small" className="contact-form" colon={false}>
            <Form.Item
              name={['user', 'name']}
              label={<FormattedMessage id="contact.form.name" defaultMessage="Full name"/>}
              rules={[{required: true, message: <FormattedMessage id="contact.form.name.required" defaultMessage="Please enter your name."/>}]}
            >
              <Input placeholder="text"/>
            </Form.Item>
            <Form.Item
              name={['user', 'companyName']}
              label={<FormattedMessage id="contact.form.companyName" defaultMessage="Company name"/>}
              rules={[{required: true, message: <FormattedMessage id="contact.form.companyName.required" defaultMessage="Please enter your company name."/>}]}
            >
              <Input placeholder="text"/>
            </Form.Item>
            <Form.Item
              name={['user', 'email']}
              label={<FormattedMessage id="contact.form.email" defaultMessage="Email address"/>}
              rules={[
                { required: true, message: <FormattedMessage id="contact.form.email.required" defaultMessage="Please provide a valid email address."/> },
                { type: 'email', message : <FormattedMessage id="contact.form.email.type" defaultMessage="Invalid email address."/> }
              ]}
            >
              <Input placeholder="example@mojitok.com"/>
            </Form.Item>
            <Form.Item 
              name={['user', 'message']}
              label={<FormattedMessage id="contact.form.message" defaultMessage="Tell us more"/>}
            >
              <Input.TextArea placeholder="text" style={{height:100}}/>
            </Form.Item>
            <Form.Item style={{display:'flex', justifyContent:'center'}}>
              <Button type="primary" htmlType="submit" className="contact-form-button">
                <FormattedMessage id="contact.button" defaultMessage="Send"/>
              </Button>
            </Form.Item>
          </Form> 
        
        
        </div>
      </div>
    </div>
  )
}

export default Home;
